import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index7',
  templateUrl: './index7.component.html',
  styleUrls: ['./index7.component.scss']
})
/**
 * Index-7 component
 */
export class Index7Component implements OnInit {

  constructor() { }

  currentSection = 'home';

  ngOnInit(): void {

    this.fetchData();

    let i = 1;
    setInterval(() => {
      if (i === 1) { (<HTMLImageElement>document.querySelector("#isSlideImage")).src = 'assets/images/slide-1.jpg'; }
      else if (i === 2) { (<HTMLImageElement>document.querySelector("#isSlideImage")).src = 'assets/images/slide-2.jpg'; }
      else { (<HTMLImageElement>document.querySelector("#isSlideImage")).src = 'assets/images/slide-3.jpg'; }
      if (i >= 3) { i = 0; }
      i++;
    }, 2500);
  }

  private fetchData() {
    let i = 1;
    setInterval(() => {
      // tslint:disable-next-line: max-line-length
      if (i === 1) { document.getElementById('text').innerHTML = 'We love make things amazing and simple'; } 
      else if (i === 2) { document.getElementById('text').innerHTML = 'Create amazing landing page with Globing'; } 
      else { document.getElementById('text').innerHTML = 'Perfact solution for small businesses'; }
      if (i >= 3) { i = 0; }
      i++;
    }, 2500);
  }

  /**
   * Window scroll method
   */
  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (document.body.scrollTop > 40 || document.documentElement.scrollTop > 40) {
      navbar.style.backgroundColor = '#1a1a1a';
      navbar.style.padding = '15px 0px';
    }
    else {
      navbar.style.backgroundColor = '';
      navbar.style.padding = '20px';
    }
  }

  /**
   * Toggle navbar
   */
  toggleMenu() {
    document.getElementById('navbarCollapse').classList.toggle('show');
  }

  /**
   * Section changed method
   * @param sectionId specify the current sectionID
   */
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }
}
